import React from 'react';
import Heading from './components/Heading/Heading';
import GameControlPanel from './components/GameControlPanel/GameControlPanel';
import Games from './components/Games/Games';
import PaginationComponent from './components/PaginationComponent/PaginationComponent';
import style from './GameSection.module.scss';

const GameSection: React.FC = () => {
	return (
		<div className={style.container} data-test="GameSection">
			<div className={style.wrapper}>
				<Heading />
				<GameControlPanel />
				<Games />
				<PaginationComponent />
			</div>
		</div>
	);
};

export default GameSection;
